
/*
 lans = {
     name: [zh-CN, zh-TW, ...en(other)]
 }

name: module+value
*/
// 翻译数据（5MB+）改为运行时按需加载，避免打进 app.js。
// 通过 loadLanInfo() 在应用挂载前拉取，getLan 读取这里的 lanInfo。
let lanInfo = {}

// 作为静态资源提供：开发/生产均可通过 /static 访问
const LAN_URL = '/static/i18n/i18nInfo.json'

const loadLanInfo = function() {
    return fetch(LAN_URL)
        .then(function(res) { return res.json() })
        .then(function(data) { lanInfo = data || {}; return lanInfo })
        .catch(function(e) { console.error('[i18n] 翻译加载失败:', e); lanInfo = {}; return lanInfo })
}

const getLan = function(name, mode, valueInfo) {
    let type = this.bus.nowLan
    if (mode === 1) {
        return valueInfo
    }
    if (mode === 2) {
        console.log(valueInfo)
        if (!valueInfo[type]) {
            return valueInfo.en
        }
        return valueInfo[type]
    }
    
    if (!lanInfo[name]) {
        return ''
    }
    if (!lanInfo[name][type]) {
        return lanInfo[name]['en']
    }
    return lanInfo[name][type]
}

const getImg = function(nameList) {
    let type = this.bus.nowLan
    if (nameList.length === 2 && type !== 'zh-CN') {
        return nameList[nameList.length - 1]
    }
    if (type === 'zh-CN') {
        return nameList[0]
    } else if (type === 'zh-TW') {
        return nameList[1]
    } else {
        return nameList[nameList.length - 1]
    }
}
const isEn = function() {
    return this.bus.nowLan === ''
}
export {
    getLan,
    getImg,
    isEn,
    loadLanInfo
}


// WEBPACK FOOTER //
// ./src/i18n/i18nLan.js